export const buscarServico = async (id) => {
  try {
    const url = `${process.env.REACT_APP_URL_API}/servicosCompleto?id=${id}`; // Ajustei a URL para corresponder ao padrão REST
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(`Erro ao buscar o serviço: ${data.message}`);
    }

    // Verifica se o serviço foi encontrado
    if (!data || data.length === 0) {
      throw new Error("Serviço não encontrado");
    }

    // Verifica se o serviço tem a estrutura esperada
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
};
